"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var owa_assert_1 = require("owa-assert");
function getViewFilterDisplay(filter) {
    switch (filter) {
        case 'All':
            return owa_mail_strings_1.default.allFilter;
        case 'Unread':
            return owa_mail_strings_1.default.unreadFilter;
        case 'Flagged':
            return owa_mail_strings_1.default.flaggedFilter;
        case 'ToOrCcMe':
            return owa_mail_strings_1.default.toMeFilter;
        case 'HasAttachment':
        case 'TaskActive':
        case 'TaskOverdue':
        case 'TaskCompleted':
        case 'DeprecatedSuggestions':
        case 'DeprecatedSuggestionsRespond':
        case 'DeprecatedSuggestionsDelete':
        case 'DeprecatedNoClutter':
        case 'DeprecatedClutter':
        case 'SystemCategory':
        case 'UserCategory':
        case 'Pinned':
        case 'Focused':
        case 'Locked':
        case 'Mentioned':
        case 'Hashtag':
            throw new Error('Filter not implemented');
        default:
            return owa_assert_1.assertNever(filter);
    }
}
exports.default = getViewFilterDisplay;
//# sourceMappingURL=getViewFilterDisplay.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-list-filter-view/lib/helpers/getViewFilterDisplay.js
// module id = 2267
// module chunks = 46 105